<template>
    <v-container fluid ma-0 pa-0>
        <v-layout row>
             <div class="pagecontainerapikeys">
                <v-layout row class="mediumMargin layouttitletop">
                    <v-flex xs12>
                        <span class="header-title">{{$t('InsuranceAPI.ApiKeys.API_KEY_TITLE')}}</span>
                    </v-flex>
                </v-layout>
                 <v-layout row>
                     <div class="listapikeys">
                        <div class="apikeyitem" v-for="packageItem in packages"  :key="packageItem.code">
                            <div class="apikeyinfo">
                                <span class="apikeytitle"> {{getPackageName(packageItem.code)}}  </span>
                                <span class="subtitledescription">
                                    {{getPackageDescription(packageItem.code)}}
                                </span>
                                <span v-if="packageItem.KeysCount < maxKeysPerPackage" v-on:click="requestNewApikey(packageItem.code)" class="link requestapikey">
                                    {{$t('InsuranceAPI.ApiKeys.REQUEST_KEY_BTN')}}
                                </span>
                            </div>
                            <div class="apikeydetails">
                                <div class="apikeydetailslistcontent">
                                    <div class="apikeydetailscontent" v-for="key in packageItem.keys.slice(0, 5)"  :key="key">
                                    <span v-if="packageItem.KeysCount > 1" v-on:click="deleteApiKey(packageItem.code,key)" class="icon-trash right icon-trash-apikey"></span>

                                      <v-tooltip  top>
                                        <template v-slot:activator="{ on }">
                                          <span v-on:mouseover="initializeIsKeyCopied" v-on:mouseleave="initializeIsKeyCopied" class="icon-duplicate right" v-on:click="copieApiKeyToClipboard(key)" v-on="on"></span>
                                        </template>
                                        <span >{{isKeyCopied ? 'Copied': 'Copy to clipboard'}}</span>
                                      </v-tooltip>

                                    <span class="keyvalue right">
                                            {{key}}
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-layout>
             </div>
        </v-layout>
      <DeleteApiKeyPopup/>
    </v-container>
</template>
<script>
import accountApi from '@/services/AccountApi'
import DeleteApiKeyPopup from '@/components/developer/apikeys/DeleteApiKeyPopup'
import authApi from '@/services/Auth'
import { mapState } from 'vuex'
export default {
  components: {
    DeleteApiKeyPopup
  },
  data () {
    return {
      maxKeysPerPackage: 3,
      isKeyCopied: false,
      canRequestApiKey: true,
      snackbar: {
        show: false,
        color: 'success',
        text: this.$t('InsuranceAPI.ApiKeys.API_KEYS_GENERATED_DESC'),
        timeout: 6000
      }
    }
  },
  methods: {
    getPackageName: function (packageKey) {
      let pck = this.packagesDescription.find(function (packageDescription) {
        return packageKey === packageDescription.code
      })
      return pck != null ? pck.name : packageKey
    },
    getPackageDescription: function (packageKey) {
      let pck = this.packagesDescription.find(function (packageDescription) {
        return packageKey === packageDescription.code
      })
      return pck != null ? this.$t(pck.description) : packageKey
    },
    async requestNewApikey (packageName) {
      if (this.canRequestApiKey) {
        this.canRequestApiKey = false
        let sucess = await accountApi.requestNewApiKey(packageName)
        if (sucess) {
          this.snackbar.show = true
          this.$store.dispatch('global/setSnackbar', this.snackbar)
          await this.$store.dispatch('userdetails/loadUserPackages')
          await authApi.refreshUserPackagesStorage()
        }
        this.canRequestApiKey = true
      }
    },
    deleteApiKey (packageCode, packageKey) {
      let packageToDelete = {
        code: packageCode,
        key: packageKey,
        modalPopup: true
      }
      this.$store.dispatch('userdetails/setPackageToDelete', packageToDelete)
    },
    copieApiKeyToClipboard (apiKey) {
      this.isKeyCopied = this.$copyToClipboard(apiKey)
    },
    initializeIsKeyCopied: function () {
      this.isKeyCopied = false
    }
  },
  computed: {
    ...mapState('userdetails', ['packages', 'packagesDescription'])
  }
}
</script>
